export { default } from './BeachBackground';
export type { default as BeachBackground } from './BeachBackground';